export default __webpack_public_path__ + "assets/partly-cloudy-day-fog.e72963cc.svg";